import _taggedTemplateLiteral from "/drone/src/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    height: 16px;\n    width: 16px;\n    position: absolute;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n\n    &::before {\n        background-color: ", ";\n        width: 10px;\n        height: 10px;\n        content: '';\n        transition: transform 200s ease-out;\n        transform: rotate(45deg);\n        transform-origin: center;\n    }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    &[data-popper-placement^='top'] > .", " {\n        bottom: -8px;\n    }\n    &[data-popper-placement^='bottom'] > .", " {\n        top: -8px;\n    }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import { css } from 'styled-components';
import { color } from '../system';
export var popperArrowPlacement = function popperArrowPlacement(arrowClassName) {
  return css(_templateObject(), arrowClassName, arrowClassName);
};
export var popperArrow = function popperArrow() {
  return css(_templateObject2(), color('neutral.00'));
};